import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/leilei/Documents/wahala/valjratt/school-finder/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/leilei/Documents/wahala/valjratt/school-finder/components/SchoolFinder.tsx");
